import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import getTooltipDirection from "../../../common/utility/getTooltipDirection";
import TooltipPropsType from "../../../types/interfaces/TooltipPropsType";

export default function Tooltip({
  domRect,
  text,
  position,
  widthMax,
  adjust,
  className,
}: TooltipPropsType) {
  const ref = useRef<any>(null);
  const [top, setTop] = useState<any>();
  const [left, setLeft] = useState<any>();
  const [positionClass, setPositionClass] = useState<any>("");

  useLayoutEffect(() => {
    const { top, left, positionClass } = getTooltipDirection(
      domRect,
      ref,
      position
    );
    setTop(top);
    setLeft(left);
    setPositionClass(positionClass);
  }, [domRect, ref, position]);

  const adjustTop = adjust?.top ? adjust.top : 0;
  const adjustLeft = adjust?.left ? adjust.left : 0;

  return domRect ? (
    <div
      style={{
        top: top + adjustTop,
        left: left + adjustLeft,
        height: "max-content",
        maxWidth: widthMax,
        textAlign: "left",
        wordBreak: "break-word",
        hyphens: "auto",
        whiteSpace: "pre-wrap",
        visibility: "visible",
      }}
      className={`cnv-tooltip-main-design ${positionClass} ${className || ''}`}
      ref={ref}
    >
      {text}
    </div>
  ) : null;
}
